import { makeStyles } from "@mui/styles";
import { colors } from "../../../../styles/colors";

const useStyles = makeStyles({
  eventDetailRoot: {
    backgroundColor: colors.bgcolor,
    minHeight: 'var(--app-vh)',
  },
  contentMain: {
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
  },
  container: {
    padding: '32px',
    maxWidth: '1400px',
    margin: '0 auto',
  },
  headerSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '32px',
    gap: '16px',
    flexWrap: 'wrap',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    flex: 1,
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  vehicleInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  detailsCard: {
    backgroundColor: colors.surface,
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    marginBottom: '24px',
    overflow: 'hidden',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '24px',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  documentsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '16px',
  },
  documentCard: {
    padding: '16px',
    border: `1px solid ${colors.borderLight}`,
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    backgroundColor: colors.backgroundLight,
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      borderColor: colors.primary,
    },
  },
  documentInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  documentActions: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px',
    gap: '16px',
    textAlign: 'center',
  },
  actionSection: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '16px',
    flexWrap: 'wrap',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px',
    gap: '24px',
    minHeight: '400px',
  },
});

export default useStyles;